import AgoraRTC, { ILocalVideoTrack } from 'agora-rtc-sdk-ng'
import EventEmitter from 'events'
import { fabric } from 'fabric'

import worker_script from '@/utils/workers'

import { Correct } from '.'

export interface FabricTrackCof {
  deviceId: string
  correct: Correct
  width: number
  height: number
  preserveObjectStacking?: boolean
}

export default class FabricTrack extends EventEmitter {
  private element: HTMLCanvasElement
  private canvas: fabric.Canvas
  private worker: Worker
  private videoTrack: MediaStreamTrack | null = null
  private webcam: fabric.Image | null = null
  private correct: Correct = 0
  private width: number
  private height: number
  public localVideoTrack: ILocalVideoTrack

  constructor(cof: FabricTrackCof) {
    super()
    const { deviceId, correct, width, height, preserveObjectStacking } = cof
    this.correct = correct
    this.width = width
    this.height = height
    this.element = document.createElement('canvas')
    this.element.width = width
    this.element.height = height

    const playerCanvasStream = this.element.captureStream(15)

    this.localVideoTrack = AgoraRTC.createCustomVideoTrack({
      width: width,
      height: height,
      bitrateMin: 910,
      bitrateMax: 2000,
      mediaStreamTrack: playerCanvasStream.getVideoTracks()[0],
      optimizationMode: 'motion'
    })

    this.canvas = new fabric.Canvas(this.element)
    this.canvas.preserveObjectStacking = preserveObjectStacking || true
    this.worker = new Worker(worker_script)
    const canvas = this.canvas
    this.worker.onmessage = function () {
      canvas.renderAll()
    }

    this.create(deviceId)
  }

  private create(deviceId: string) {
    window.navigator.mediaDevices
      .getUserMedia({
        audio: false,
        video: {
          deviceId,
          frameRate: 15,
          width: {
            max: this.width,
            ideal: this.width
          },
          height: {
            max: this.height,
            ideal: this.height
          }
        }
      })
      .then((stream) => {
        this.videoTrack = stream.getVideoTracks()[0]
        const video = document.createElement('video')
        const width = this.videoTrack.getSettings().width as number
        const height = this.videoTrack.getSettings().height as number
        video.style.display = 'none'
        video.setAttribute('width', String(width))
        video.setAttribute('height', String(height))
        video.srcObject = stream

        this.webcam = new fabric.Image(video)
        this.canvas.add(this.webcam)
        this.webcam.moveTo(0)
        // 锁定
        // this.webcam.set('selectable', true).setCoords()
        // 全屏
        this.webcam.set({
          left: -(width * (this.height / height) - this.width) / 2,
          top: 0,
          originX: 'left',
          originY: 'top',
          scaleX: this.height / height,
          scaleY: this.height / height
        })

        this.setCorrect(this.correct)
        ;(this.webcam.getElement() as HTMLVideoElement).play()
      })
  }

  public async setDevice(deviceId: string) {
    this.close()
    this.create(deviceId)
  }

  public async setEnabled(enabled: boolean) {}

  public setCorrect(status: Correct) {
    this.correct = status
    this.webcam?.set({ flipY: false })
    this.webcam?.set({ flipX: false })
    status === 2 && this.webcam?.set({ flipY: true })
    status === 3 && this.webcam?.set({ flipX: true })
    if (status === 4) {
      this.webcam?.set({ flipY: true })
      this.webcam?.set({ flipX: true })
    }
  }

  private close() {
    this.videoTrack?.stop()
    this.webcam && this.canvas.remove(this.webcam)
    this.webcam = null
    this.videoTrack = null
  }

  public destroy() {
    this.close()
    this.worker.postMessage({ cdm: 'stop' })
    this.worker.terminate()
  }
}
